import Swal from "sweetalert2";
import { fetchSinToken, fetchConToken } from "../helpers/fetch";
import { types } from "../types/types";


export const startLogin = ( email, password ) => {

    return async( dispatch ) => {

        const resp = await fetchSinToken( 'auth', { email, password }, 'POST' );
        const { ok, token, uid, name, msg } = await resp.json();

        if ( ok ) {

            localStorage.setItem( 'token', token );
            localStorage.setItem( 'token-init-date', new Date().getTime() );

            dispatch(
                login( { uid, name } )
            )
        } else {
            Swal.fire( 'Error', msg, 'error' );
        }

    }
}


export const startRegister = ( name, email, password ) => {

    return async( dispatch ) => {

        
        const resp = await fetchSinToken( 'auth/register', { email, password, name }, 'POST' );
        const body = await resp.json();


        if ( body.ok ) {
            localStorage.setItem( 'token', body.token );
            localStorage.setItem( 'token-init-date', new Date().getTime() );


            dispatch(
                login( {
                    uid: body.uid,
                    name: body.name
                })
            )
        } else {

            Swal.fire( 'Error', body.msg, 'error' );
        }
    }
}


export const startChecking = () => {

    return async ( dispatch ) => {

        const resp = await fetchConToken( 'auth/renew' );
        const body = await resp.json();


        if ( body.ok ) {
            localStorage.setItem( 'token', body.token );
            localStorage.setItem( 'token-init-date', new Date().getTime() );

            dispatch(
                login( {
                    uid: body.uid,
                    name: body.name
                })
            )
        } else {
            dispatch( checkingFinish() );
        }
    }
}


export const startLogout = () => {

    return ( dispatch ) => {
        localStorage.clear();
        dispatch( logout() );
    }
}

export const checkingFinish = () => ({ type: types.authCheckingFinish })

const login = ( user ) => ({
    type: types.authLogin,
    payload: user
})

const logout = () => ({ type: types.authLogout })

